import {
  fork,
  put,
  all,
  call,
  takeLatest,
} from "redux-saga/effects";

import {
  GET_GLOBAL_IAAC,
  PUT_GLOBAL_IAAC,
  CLEAR_ALL_GLOBAL_IAAC_MESSAGES,
} from "./actionTypes";

import { 
  getGlobalIaacSuccessful,
  getGlobalIaacFailure,
  putGlobalIaacSuccessful,
  putGlobalIaacFailure,
  clearAllGlobalIaacMessagesSuccessful as clearAllGlobalIaacMessagesSuccessfulAction
} from "./actions";

import {
  getGlobalIaac as getGlobalIaacApi,
  putGlobalIaac as putGlobalIaacApi,  
} from "../../helpers/auth_helper";

function* getGlobalIaac({payload: { orgCode } }) {
  try {
    const response = yield call(getGlobalIaacApi, orgCode);
    console.log("getGlobalIaacApi Response: ", response);
    if( response && response.status === 200 ){
      delete response.status;
      yield put(getGlobalIaacSuccessful(response));
    } else {
      let message;
      if(response.message) {
        message = response.message;
      } else {
        message = response;
      }
      yield put(getGlobalIaacFailure({ message: message }));

    }
  } catch (error) {
    console.log("getGlobalIaacApi Error: ", error);
    if(error.response){
      yield put(getGlobalIaacFailure({message: "Error Code: "+error.response?.status+", Message: "+error.response?.data}));
    } else if(error.request){
      yield put(getGlobalIaacFailure({message: "No response is received"}))
    } else{
      yield put(getGlobalIaacFailure({message: error?.message}));
    }
  }
}

function* updateGlobalIaac({payload: { iaac } }) {
  try {
    const response = yield call(putGlobalIaacApi, iaac);
    console.log("putGlobalIaacApi Response: ", response);
    if( response && response.status === 200 ){
      delete response.status;
      yield put(putGlobalIaacSuccessful(response.data));
    } else {
      let message;
      if(response.message) {
        message = response.message;
      } else {
        message = response;
      }
      yield put(putGlobalIaacFailure({ message: message }));
    }
  } catch (error) {
    console.log("putGlobalIaacApi Error: ", error);
    if(error.response){
      yield put(putGlobalIaacFailure({message: "Error Code: "+error.response?.status+", Message: "+error.response?.data}));
    } else if(error.request){
      yield put(putGlobalIaacFailure({message: "No response is received"}))
    } else{
      yield put(putGlobalIaacFailure({message: error?.message}));
    }
  }
}

export function* clearAllGlobalIaacMessages() {
  console.log("globalIaac Saga: clear all messages");
  yield put(clearAllGlobalIaacMessagesSuccessfulAction());
}

function* watchGlobalIaac() {
  yield takeLatest(GET_GLOBAL_IAAC, getGlobalIaac);
  yield takeLatest(PUT_GLOBAL_IAAC, updateGlobalIaac);
  yield takeLatest(CLEAR_ALL_GLOBAL_IAAC_MESSAGES, clearAllGlobalIaacMessages);
}

function* globalIaacSaga() {
  yield all([fork(watchGlobalIaac)])
}

export default globalIaacSaga;